import gql from 'graphql-tag'

export const GET_CUSTOMER_CATEGORY = gql`
  query getCustomerCategoryList ($page: Int, $perPage: Int) {
    customerCategoryList (page: $page, perPage: $perPage) {
      hasNextPage
      nodes {
        id
        name
      }
    }
  }
`
export default {
  GET_CUSTOMER_CATEGORY
}
